import { SvgSymbolIds } from '../constants';
interface Props {
  className?: string;
}
export function Toman({
  className = 'w-8 fill-text-black'
}: Props) {
  return <svg className={className} data-sentry-element="svg" data-sentry-component="Toman" data-sentry-source-file="toman.tsx">
            <use href={`#${SvgSymbolIds.Toman}`} data-sentry-element="use" data-sentry-source-file="toman.tsx" />
        </svg>;
}